/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.3
 * @since 1.1.0
 */

import { colors } from '../../../../../../theme';

export const ExpensesAnalyzerChartDynamicColors: string[] = [
    colors.chartDynamicColorPink,
    colors.chartDynamicColorAquamarine,
    colors.chartDynamicColorGreenLight,
    colors.chartDynamicColorPurpleLight,
    colors.chartDynamicColorRed,
    colors.chartDynamicColorOrangeLight,
    colors.chartDynamicColorBlue,
    colors.chartDynamicColorOrange,
    colors.chartDynamicColorBlueLight,
    colors.chartDynamicColorYellow,
];
